import HappyClientSlider from "./HappyClientSlider";
import { GoogleReviewIcon, TrustPilotIcon } from "./Icons";

const HappyClients = () => {
  return (
    <div>
      <div className="container px-5 mx-auto xl:pt-28 xl:pb-24 sm:pt-20 sm:pb-18 py-16 relative 2xl:max-w-[1240px]">
        <h2 className="xl:text-[58px] lg:text-[48px] sm:text-[40px] text-[35px] font-bold text-[#010101] text-center leading-[120%] pb-2">
          Our Happy Clients
        </h2>
        <div className="flex flex-col sm:flex-row gap-5 items-center justify-center sm:pt-5 pt-7">
          <div>
            <TrustPilotIcon />
          </div>
          <div>
            <GoogleReviewIcon />
          </div>
        </div>
        <HappyClientSlider />
      </div>
    </div>
  );
};

export default HappyClients;
